import {
    DECOUPE_FORMS, DECOUPE_FORMS_BOIS_ONLY,
    DECOUPE_FORMS_BOIS_PLEXI_MV, DECOUPE_FORMS_MV_ONLY,
    MATERIAL_DENSITY, MATERIAL_MIN_PRICE,
    MATERIAL_PRICE,
    PLIAGE_FORMS,
    PRICE_PER_PLI
} from "./materials";
import {
    MAX_A,
    MAX_B,
    MIN_A,
    MIN_B,
    MIN_DEGREE,
    MV_D_ALLOW, PRIX_PAR_PERCAGE_DOUBLE_TRIPLE_MV, PRIX_PAR_PERCAGE_SIMPLE_MV,
    PRIX_PAR_PLIAGE, PRIX_SUPP_USINAGE_ET_PLACAGE_FORM,
    TYPE_DECOUPE,
    TYPE_PLIAGE
} from "./constants";


export const getMaxX = (shade, dimension, forSymetric = false) => {
    const border = forSymetric ? 20 : 10;
    let maxX = getMaxA(shade) - border;
    if (dimension && dimension.A) {
        maxX = dimension.A - border;
    }

    return maxX;
}

export const getMaxY = (shade, dimension, forSymetric= false) => {
    const border = forSymetric ? 20 : 10;
    let maxY = getMaxB(shade) - border;
    if (dimension && dimension.B) {
        maxY = dimension.B - border;
    }

    return maxY;
}

export const getMaxOfMin = (shade, dimension, forSymetric = false) => {
    const maxX = getMaxX(shade, dimension, forSymetric);
    const maxY = getMaxY(shade, dimension, forSymetric);
    return Math.min(maxX, maxY);
}

export const getMaxDA = (shade, dimension) => {
    let maxDA = getMaxB(shade);
    if (dimension && dimension.B && dimension.y) {
        maxDA = dimension.B - dimension.y - 20;
    } else {
        maxDA = maxDA - 20;
    }
    return maxDA;
}
export const getMaxDB = (shade, dimension) => {
    let maxDB = getMaxA(shade);
    if (dimension && dimension.A && dimension.x) {
        maxDB = dimension.A - dimension.x - 20;
    } else {
        maxDB = maxDB - 20;
    }
    return maxDB;
}

export function validateInput(thisDimension, thisInput, thisThickness, type, form, shade)  {
    if (type === TYPE_DECOUPE) {
        if (thisInput === "A") {
            if (!thisDimension || (thisDimension && !thisDimension.A)) {
                return true;
            } else {
                let thisMax = getMaxA(shade);
                if (form === 'disque' || form === 'anneau') {
                    thisMax = getMaxB(shade);
                }
                if (thisDimension.A >= getMinA(shade) && thisDimension.A <= thisMax) {
                    return true;
                }
            }
        }
        if (thisInput === "B") {
            if (!thisDimension || (thisDimension && !thisDimension.B)) {
                return true;
            } else {
                if (thisDimension.B >= getMinB(shade) && thisDimension.B <= getMaxB(shade)) {
                    return true;
                }
            }
        }
        if (thisInput === "dA") {
            let min = 10;
            let max = getMaxDA(shade, thisDimension);
            if (!thisDimension || (thisDimension && !thisDimension.dA)) {
                return true;
            } else {
                if (!thisDimension.B || !thisDimension.y) {
                    return true;
                } else {
                    if (thisDimension['dA'] >= min && thisDimension['dA'] <= max) {
                        return true;
                    }
                }
            }
        }
        if (thisInput === "dB") {
            let min = 10;
            let max = getMaxDB(shade, thisDimension);
            if (!thisDimension || (thisDimension && !thisDimension.dB)) {
                return true;
            } else {
                if (!thisDimension.A || !thisDimension.x) {
                    return true;
                } else {
                    if (thisDimension.dB >= min && thisDimension.dB <= max) {
                        return true;
                    }
                }
            }
        }
        if (thisInput === "x") {
            if (form === 'mv-rect-percage' || form === 'mv-rect-double' || form === 'mv-rect-triple') {
                return MV_D_ALLOW.includes(parseInt(thisDimension.x));
            } else {
                let min = thisThickness;
                let max = getMaxX(shade, thisDimension);
                if (form === 'cadre-cr' || form === 'rect-enc' || form === 'trapeze') {
                    max = getMaxX(shade, thisDimension, true);
                }
                if (form === 'cadre-cc' || form === 'anneau') {
                    max = getMaxOfMin(shade, thisDimension, true);
                }
                if (form === 'croix' || form === 'rect-coin-b' || form === 'rect-percage') {
                    max = getMaxX(shade, thisDimension, true) / 2
                }
                if (form === 'bpmv_arc') {
                    min = 10;
                    max = max = thisDimension?.A ? thisDimension.A / 2 : 1000;
                }
                if (!thisDimension || (thisDimension && !thisDimension.x)) {
                    return true;
                } else {
                    if (!thisDimension.A) {
                        return true;
                    } else {
                        if (thisDimension.x >= min && thisDimension.x <= max) {
                            return true;
                        }
                    }
                }
            }
        }
        if (thisInput === "y") {
            //let min = thisThickness;
            let min = 20;
            let max = getMaxY(shade, thisDimension);
            if (form === 'cadre-cr' || form === 'rect-enc') {
                //max = getMaxOfMin(shade, thisDimension, true);
                max = getMaxY(shade, thisDimension,true)
            }
            if (form === 'croix' || form === 'rect-coin-b' || form === 'rect-percage') {
                max = getMaxY(shade, thisDimension,true) / 2
            }
            if (!thisDimension || (thisDimension && !thisDimension.x)) {
                return true;
            } else {
                if (!thisDimension.B) {
                    return true;
                } else {
                    if (thisDimension.y >= min && thisDimension.y <= max) {
                        return true;
                    }
                }
            }
        }
    } else {
        if (thisInput === "A" || thisInput === "B" || thisInput === "C" ||thisInput === "D" ||thisInput === "E") {
            let min = thisThickness <= 2 ? getMinB(shade) : 20;
            let totalWidth = 0;
            ["A", "B", "C", "D", "E"].map((inputName) => {
                if (thisDimension[inputName]) {
                    totalWidth += parseInt(thisDimension[inputName]);
                }
            });
            if (totalWidth > getMaxB(shade)) {
                return false;
            }
            if (!thisDimension || (thisDimension && !thisDimension[thisInput])) {
                return true;
            } else {
                if (thisDimension[thisInput] >= min && thisDimension[thisInput] <= getMaxB(shade)) {
                    return true;
                }
            }
        }
        if (thisInput === "P") {
            if (!thisDimension || (thisDimension && !thisDimension.P)) {
                return true;
            } else {
                if (thisDimension.P >= getMinA(shade) && thisDimension.P <= getMaxA(shade)) {
                    return true;
                }
            }
        }
        if (["1", "2", "3", "4"].includes(thisInput)) {
            if (thisDimension[thisInput] >= MIN_DEGREE && thisDimension[thisInput] <= 180) {
                return true;
            }
        }
    }
    return false;
}

export function areDimensionsConstraintValidated(shade, form, dimensions, thickness, type = TYPE_DECOUPE) {
    if (dimensions) {
        if (type === TYPE_PLIAGE) {
            let totalWidth = 0;
            ["A", "B", "C", "D", "E"].map((inputName) => {
               if (dimensions[inputName]) {
                   totalWidth += parseInt(dimensions[inputName]);
               }
            });
            if (totalWidth > getMaxB(shade)) {
                return false;
            }
        }
        for (let key of Object.keys(dimensions)) {
            if (!validateInput(dimensions, key, thickness, type, form, shade)) {
                return false;
            }
        }
    }
    return true;
}
export function areDimensionsFilled(formId, dimensions) {
    if (!dimensions) {
        return false;
    }
    const formListDecoupe = Object.keys(DECOUPE_FORMS);
    const formListPliage = Object.keys(PLIAGE_FORMS);
    const formListBPMV = Object.keys(DECOUPE_FORMS_BOIS_PLEXI_MV);
    const formListBoisOnly = Object.keys(DECOUPE_FORMS_BOIS_ONLY);
    const formListMVOnly = Object.keys(DECOUPE_FORMS_MV_ONLY);

    let dimensionInputList = [];
    if (formListPliage.includes(formId)) {
        dimensionInputList = PLIAGE_FORMS[formId].dimensions;
    }
    if (formListDecoupe.includes(formId)) {
        dimensionInputList = DECOUPE_FORMS[formId].dimensions;
    }
    if (formListBPMV.includes(formId)) {
        dimensionInputList = DECOUPE_FORMS_BOIS_PLEXI_MV[formId].dimensions;
    }
    if (formListBoisOnly.includes(formId)) {
        dimensionInputList = DECOUPE_FORMS_BOIS_ONLY[formId].dimensions;
    }
    if (formListMVOnly.includes(formId)) {
        dimensionInputList = DECOUPE_FORMS_MV_ONLY[formId].dimensions;
    }

    if (dimensionInputList.length > 0) {
        for (let i=0; i< dimensionInputList.length; i++) {
            if (!dimensions[dimensionInputList[i]]) {
                return false;
            }
        }
    } else {
        return false;
    }
    return true;
}

export function getPriceFromShadeAndWeight(shade, weight) {
    if (weight < 1) {
        return MATERIAL_PRICE[shade][0];
    }
    if (weight >= 1 && weight <= 3) {
        return MATERIAL_PRICE[shade][1];
    }
    if (weight > 3) {
        return MATERIAL_PRICE[shade][2];
    }
}

export function getPriceTTC(priceHT) {
    const priceTTC = priceHT * 1.2;
    return priceTTC.toFixed(2);
}

export function computeTransportPrice(material, weight) {
    const isMajored = (material === 'miroir' || material === 'verre');
    let transportPrice = 0;
    if (weight <= 0.75) {
        transportPrice = isMajored ? 15 : 10;
    } else if (weight >= 0.751 && weight <= 1) {
        transportPrice = isMajored ? 24 : 16;
    } else if (weight >= 1.001 && weight <= 2) {
        transportPrice = isMajored ? 26.4 : 17.6;
    } else if (weight >= 2.001 && weight <= 3) {
        transportPrice = isMajored ? 31.68 : 21.12;
    } else if (weight >= 3.001 && weight <= 4) {
        transportPrice = isMajored ? 41.18 : 27.46;
    } else if (weight >= 4.001 && weight <= 5) {
        transportPrice = isMajored ? 57.66 : 38.44;
    } else if (weight >= 5.001 && weight <= 10) {
        transportPrice = isMajored ? 86.49 : 57.66;
    } else if (weight >= 10.001 && weight <= 15) {
        transportPrice = isMajored ? 95.14 : 63.42;
    } else if (weight >= 15.001 && weight <= 20) {
        transportPrice = isMajored ? 104.65 : 69.77;
    } else if (weight >= 20.001 && weight <= 25) {
        transportPrice = isMajored ? 115.11 : 76.74;
    } else if (weight >= 25.001 && weight <= 30) {
        transportPrice = isMajored ? 143.89 : 95.93;
    } else if (weight >= 30.001 && weight <= 35) {
        transportPrice = isMajored ? 179.86 : 119.91;
    } else if (weight >= 35.001 && weight <= 40) {
        transportPrice = isMajored ? 224.83 : 149.89;
    } else if (weight >= 40.001 && weight <= 45) {
        transportPrice = isMajored ? 281.04 : 187.36;
    } else if (weight >= 45.001 && weight <= 50) {
        transportPrice = isMajored ? 351.30 : 234.20;
    } else if (weight >= 50.001 && weight <= 55) {
        transportPrice = isMajored ? 439.12 : 292.75;
    } else {
        transportPrice = 599;
    }

    console.log('[DEBUG] Transport: ' + transportPrice);

    return transportPrice;
}
export function computePrice(material, shade, type, thickness, form, dimensions, quantity, option) {
    const priceUnit = getPriceFromShadeAndThickness(material, shade, thickness, form, option.length > 0);
    const surface = computeSurface(dimensions, type);
    const weight = computeWeight(type, dimensions, shade, thickness);
    let price = priceUnit * surface * quantity;

    console.log('[DEBUG] Weight: ' + weight);
    console.log('[DEBUG] Price base: ' + price);

    if (type === TYPE_PLIAGE) {
        price += PRICE_PER_PLI[form] * PRIX_PAR_PLIAGE;
    }

    if (material === 'bois-brut' || material === 'melamine') {
        if (form !== 'bpmv_rect') {
            price += surface * PRIX_SUPP_USINAGE_ET_PLACAGE_FORM;
            console.log('[DEBUG] Price SUPP bois: ' + (surface * PRIX_SUPP_USINAGE_ET_PLACAGE_FORM));
        }
    }

    if (material === 'miroir' || material === 'verre') {
        if (form === 'mv-rect-percage') {
            price += 4 * PRIX_PAR_PERCAGE_SIMPLE_MV;
            console.log('[DEBUG] + SUPP: ' + 4 * PRIX_PAR_PERCAGE_SIMPLE_MV);

        }

        if (form === 'mv-rect-double' || form === 'mv-rect-triple') {
            price += PRIX_PAR_PERCAGE_DOUBLE_TRIPLE_MV;
            console.log('[DEBUG] + SUPP: ' + PRIX_PAR_PERCAGE_DOUBLE_TRIPLE_MV);
        }
    }

    if (material !== 'acier' && material !== 'inox' && material !== 'aluminium' && material !== 'laiton') {
        // Min facture
        price = Math.max(price, getMinPriceFromShadeAndForm(material, shade, thickness, form, surface, option.length > 0));

        console.log('[DEBUG] Min facture: ' + getMinPriceFromShadeAndForm(material, shade, thickness, null, surface, false));
    }

    return price.toFixed(2);
}

export function computeDXFPrice(material, width, height, currentShade, thickness, quantity) {
    const priceUnit = getPriceDXFFromShadeAndThickness(material, currentShade, thickness);
    const surface = width/1000 * height/1000;
    const weight = computeDXFWeight(width, height, currentShade, thickness);
    let price = priceUnit * surface * quantity;

    console.log('[DEBUG] Weight: ' + weight);
    console.log('[DEBUG] Price base: ' + price);

    if (material === 'bois-brut' || material === 'melamine') {
        price += surface * PRIX_SUPP_USINAGE_ET_PLACAGE_FORM;
        console.log('[DEBUG] Price SUPP bois: ' + (surface * PRIX_SUPP_USINAGE_ET_PLACAGE_FORM));
    }

    if (material !== 'acier' && material !== 'inox' && material !== 'aluminium' && material !== 'laiton') {
        // Min facture
        price = Math.max(price, getMinPriceFromShadeAndForm(material, currentShade, thickness, null, surface, false));

        console.log('[DEBUG] Min facture: ' + getMinPriceFromShadeAndForm(material, currentShade, thickness, null, surface, false));
    }

    return price.toFixed(2);
}
export function getPriceFromShadeAndThickness(material, shade, thickness, form, hasOption) {
    if (material === 'melamine') {
        return MATERIAL_PRICE[shade][thickness][hasOption ? 'avec-chants' : 'brut'];
    }
    if (material === 'verre' || material === 'miroir') {
        return MATERIAL_PRICE[shade][thickness][getMVFormCategory(form)];
    }
    return MATERIAL_PRICE[shade][thickness] ?? 0;
}

export function getPriceDXFFromShadeAndThickness(material, shade, thickness) {
    if (material === 'melamine') {
        return MATERIAL_PRICE[shade][thickness]['avec-chants'];
    }
    if (material === 'verre' || material === 'miroir') {
        return 0;
    }
    return MATERIAL_PRICE[shade][thickness] ?? 0;
}

export function getMVFormCategory(form) {
    switch (form) {
        case "bpmv_rect":
            return 'form-a';
        case "bpmv_triangle":
            return 'form-b';
        default:
            return 'form-c';
    }

}

export function computeWeight(type, dimensions, shade, thickness) {
    if (type === TYPE_DECOUPE) {
        return computeWeightDecoupe(dimensions, shade, thickness);
    } else {
        return computeWeightPliage(dimensions, shade, thickness);
    }
}
export function computeWeightPliage(dimensions, currentShade, thickness) {
    const density = MATERIAL_DENSITY[currentShade];
    let weight = 0;
    let totalWidth = 0;
    ["A", "B", "C", "D", "E"].map((inputName) => {
        if (dimensions[inputName]) {
            totalWidth += parseInt(dimensions[inputName]);
        }
    });
    if (dimensions.P) {
        weight = dimensions.P/1000 * totalWidth/1000 * thickness * density;
        return weight.toFixed(2);
    }
    return null;
}

export function computeWeightDecoupe(dimensions, currentShade, thickness) {
    const density = MATERIAL_DENSITY[currentShade];
    let weight = 0;
    if (dimensions.B) {
        weight = dimensions.A/1000 * dimensions.B/1000 * getThicknessValue(thickness) * density;
    } else {
        weight = dimensions.A/1000 * dimensions.A/1000 * getThicknessValue(thickness) * density;
    }

    return weight.toFixed(2);
}

export function computeSurface(dimensions, type) {
    if (type === TYPE_DECOUPE) {
        if (dimensions.B) {
            return dimensions.A / 1000 * dimensions.B / 1000;
        } else {
            return dimensions.A / 1000 * dimensions.A / 1000;
        }
    } else {
        return (computeTotalWidth(dimensions)/1000) * (dimensions.P/1000);
    }
}

export function computeTotalWidth(dimensions) {
    let totalWidth = 0;
    ["A", "B", "C", "D", "E"].map((inputName) => {
        if (dimensions[inputName]) {
            totalWidth += parseInt(dimensions[inputName]);
        }
    });
    return totalWidth;
}

export function getMaterialAndShadeFromCurrentPath(path) {
    switch (path.toLowerCase()) {
        case '/metal/':
            return { materiel: 'metal', shade: null};
        case '/acier/':
            return { materiel: 'acier', shade: null};
        case '/inox/':
            return { materiel: 'inox', shade: null};
        case '/aluminium/':
            return { materiel: 'aluminium', shade: null};
        case '/laiton/':
            return { materiel: 'laiton', shade: null};
        case '/bois/':
            return { materiel: 'bois', shade: null};
        case '/bois-brut/':
            return { materiel: 'bois-brut', shade: null};
        case '/melamine/':
            return { materiel: 'melamine', shade: null};
        case '/miroir-et-verre/':
            return { materiel: 'miroir-et-verre', shade: null};
        case '/miroir/':
            return { materiel: 'miroir', shade: null};
        case '/verre/':
            return { materiel: 'verre', shade: null};
        case '/plexi/':
            return { materiel: 'plexi', shade: null};
        case '/plexi-pmma/':
            return { materiel: 'plexi-pmma', shade: null};
        case '/plexi-polycarbonate/':
            return { materiel: 'plexi-polycarbonate', shade: null};

    }
    return {materiel: null, shade: null};
}
export function computeDXFWeight(width, height, shade, thickness) {
    const density = MATERIAL_DENSITY[shade];
    const weight = width/1000 * height/1000 * getThicknessValue(thickness) * density;
    return weight.toFixed(2);
}
export function computeUnitPrice (quantity, price) {
    const res = price / quantity;
    return res.toFixed(2);
}

export function isDeg(str) {
    if (typeof str != "string") return false
    return !isNaN(str) && !isNaN(parseFloat(str))
}

export function getOptionChantsLabel(option) {
    let label = '';
    option.map((value) => {
        label = label + (label !== '' ? ', ' : '') + value;
    })
    return label;
}

export function getSizeLabel(dimension, form) {
    switch (form) {
        case "bpmv_hexagone":
        case "bpmv_cercle":
        case "disque":
            return `Diamètre: ${dimension.A}`;
        case "demis-disque-all":
        case "bpmv_arc":
        case "bpmv_triangle" :
        case "triangle":
        case "ellipse":
        case "rect":
        case "bpmv_rect":
            return `A: ${dimension.A}, B: ${dimension.B}`;
        case "anneau":
            return `A: ${dimension.A}, x: ${dimension.x}`;
        case "rect-coin-ar":
            return `A: ${dimension.A}, B: ${dimension.B}, x: ${dimension.x}`;
        case "cadre-cc":
            return `A: ${dimension.A}, B: ${dimension.B}, x: ${dimension.x}, dA: ${dimension.dA}, dB: ${dimension.dB}`;
        case "cadre-cr":
            return `A: ${dimension.A}, B: ${dimension.B}, x: ${dimension.x}, y: ${dimension.y}, dA: ${dimension.dA}, dB: ${dimension.dB}`;
        case "rect-percage":
        case "rect-cc":
        case "b_rect_enc":
        case "rect-enc":
        case "croix":
        case "rect-coin-b":
            return `A: ${dimension.A}, B: ${dimension.B}, x: ${dimension.x}, y: ${dimension.y}`;
        case "pl-f-1":
            return `A: ${dimension.A}, B: ${dimension.B}, C: ${dimension.C}, 1: ${dimension["1"]}°, 2:${dimension["2"]}°, P:${dimension.P}`;
        case "pl-f-2":
            return `A: ${dimension.A}, B: ${dimension.B}, 1: ${dimension["1"]}, P:${dimension.P}`;
        case "pl-f-3":
            return `A: ${dimension.A}, B: ${dimension.B}, C: ${dimension.C}, 1: ${dimension["1"]}°, 2:${dimension["2"]}°, P:${dimension.P}`;
        case "pl-f-4":
            return `A: ${dimension.A}, B: ${dimension.B}, C: ${dimension.C}, D: ${dimension.D}, E: ${dimension.E}, 1: ${dimension["1"]}°, 2:${dimension["2"]}°, 3: ${dimension["3"]}°, 4:${dimension["4"]}°,P:${dimension.P}`;
    }
}

export function getThicknessLabelFromValue(value) {
    if (value === 0.66) {
        return "4/6";
    }
    if (value === 0.71) {
        return "5/7";
    }
    if (value === 0.6) {
        return "3/5";
    }
    return value;
}

export function getThicknessValue(value) {
    if (value === 0.66) {
        return "4";
    }
    if (value === 0.71) {
        return "5";
    }
    if (value === 0.6) {
        return "3";
    }
    return value;
}

export function getFormFromMid(mid) {
    switch (mid) {
        case "acier":
        case "inox":
        case "aluminium":
        case "laiton":
            return DECOUPE_FORMS;
        case "plexi-pmma":
        case "plexi-polycarbonate":
            return DECOUPE_FORMS_BOIS_PLEXI_MV;
        case "miroir":
        case "verre":
            return {...DECOUPE_FORMS_BOIS_PLEXI_MV, ...DECOUPE_FORMS_MV_ONLY};
        case "bois-brut":
        case "melamine":
            return {...DECOUPE_FORMS_BOIS_PLEXI_MV, ...DECOUPE_FORMS_BOIS_ONLY};
    }
}

export function getClassNameFromMid(mid) {
    switch (mid) {
        case "bpmv_rect":
        case "bpmv_arc":
        case "bpmv_cercle":
        case "bpmv_triangle":
        case "bpmv_hexagone":
        case "mv-rect-percage":
        case "mv-rect-double":
        case "mv-rect-triple":
            return "dcf-bpmv";
        default:
            return "dcf";
    }
}

export function getMinA(shade) {
    switch (shade) {
        case "melamine-unis-noir":
        case "melamine-unis-blanc":
        case "melamine-bois-chene-clair":
        case "melamine-bois-chene-blanchis":
        case "melamine-bois-noyer":
        case "bois-brut-mdf":
        case "verre-transparent":
        case "plexi-polycarbonate-alveolaire":
            return 100;
        default:
            return MIN_A;
    }
}

export function getMinB(shade) {
    switch (shade) {
        case "melamine-unis-noir":
        case "melamine-unis-blanc":
        case "melamine-bois-chene-clair":
        case "melamine-bois-chene-blanchis":
        case "melamine-bois-noyer":
        case "bois-brut-mdf":
        case "verre-transparent":
        case "plexi-polycarbonate-alveolaire":
            return 100;
        default:
            return MIN_B;
    }
}

export function getMaxA(shade) {
    switch (shade) {
        case "acier-brut":
        case "acier-electro-zingue":
        case "acier-larme":
        case "inox-304l-brut":
        case "inox-316l":
        case "inox-brosse":
        case "inox-larme":
        case "alu-brut":
        case "alu-prelaque-blanc":
        case "laiton-brut":
            return 2980;
        case "melamine-unis-noir":
        case "melamine-unis-blanc":
        case "melamine-bois-chene-clair":
        case "melamine-bois-chene-blanchis":
        case "melamine-bois-noyer":
            return 2750;
        case "bois-brut-mdf":
            return 2970;
        case "plexi-pmma-noir":
        case "plexi-pmma-blanc":
        case "plexi-pmma-transparent":
        case "plexi-pmma-diffusant":
        case "plexi-polycarbonate-transparent":
        case "plexi-polycarbonate-alveolaire":
            return 3000;
        case "verre-transparent":
        case "verre-noir":
        case "verre-blanc":
        case "verre-transparent-trempe":
        case "miroir-clair":
            return 2000;
        default:
            return 3000;
    }
}
export function getMaxB(shade) {
    switch (shade) {
        case "acier-brut":
        case "acier-electro-zingue":
        case "acier-larme":
        case "inox-304l-brut":
        case "inox-316l":
        case "inox-brosse":
        case "inox-larme":
        case "alu-brut":
        case "alu-prelaque-blanc":
        case "laiton-brut":
            return 1480;
        case "melamine-unis-noir":
        case "melamine-unis-blanc":
        case "melamine-bois-chene-clair":
        case "melamine-bois-chene-blanchis":
        case "melamine-bois-noyer":
            return 2020;
        case "bois-brut-mdf":
            return 2020;
        case "plexi-pmma-noir":
        case "plexi-pmma-blanc":
        case "plexi-pmma-transparent":
        case "plexi-pmma-diffusant":
        case "plexi-polycarbonate-transparent":
            return 2000;
        case "plexi-polycarbonate-alveolaire":
            return 1200
        case "verre-transparent":
        case "verre-noir":
        case "verre-blanc":
        case "verre-transparent-trempe":
        case "miroir-clair":
            return 1000;
        default:
            return 1480;
    }
}

export function getMinPriceFromShadeAndForm(material, shade, thickness, form, surface, hasOption) {
    console.log(shade);
    if (material === 'acier' || material === 'inox' || material === 'aluminium' || material === 'laiton') {
        return 40;
    }

    if (material === 'plexi-pmma' || material === 'plexi-polycarbonate') {
        return 40;
    }

    if (material === 'bois-brut' || material === 'melamine') {
        if (surface < 0.3) {
            if (material === 'melamine') {
                return MATERIAL_MIN_PRICE[shade][thickness][hasOption ? 'avec-chants' : 'brut'];
            } else {
                return MATERIAL_MIN_PRICE[shade][thickness];
            }
        }
    }

    if (form && material === 'miroir' || material === 'verre') {
        if (surface < 0.45) {
            return MATERIAL_MIN_PRICE[shade][thickness][getMVFormCategory(form)];
        }
    }

    return 0;
}